export const DEFAULT_MANAGER_SETTINGS = {
	keys: {
		first: { keyCode: 35 },
		last: { keyCode: 36 },
		next: [{ keyCode: 39 }, { keyCode: 40 }],
		prev: [{ keyCode: 37 }, { keyCode: 38 }]
	},
	searchDelay: 800,
	searchKey: undefined,
	stringSearch: false,
	wrap: true	
}

export const DEFAULT_MATCHER_KEYS = {
	altKey: false,
	ctrlKey: false,
	metaKey: false,
	shiftKey: false
}

export const FOCUS_ALLOW = 'no-focus-lock'
export const FOCUS_AUTO = 'autofocus-inside'
export const FOCUS_DISABLED = 'focus-lock-disabled'
export const FOCUS_GROUP = 'focus-lock'

export const TABBABLE_ITEMS = [
	'a[href]',
	'area[href]',
	'[autofocus]',
	'button:enabled:not([readonly])',
	'[contenteditable]',
	'embed',
	'iframe',
	'input:enabled:not([readonly])',
	'object',
	'select:enabled:not([readonly])',
	'[tabindex]',
	'textarea:enabled:not([readyonly])'
]

export const VALID_FOCUSABLE_TAGS = /(svg|a|area|input|select|textarea|button|iframe|div)$/
export const VALID_FIRST_FOCUS_TAGS = /(input|select|textarea)$/
export const RECIEPT_CHECKOUT_TYPES = {
  REQUISITION_REQUESTED : 'Requisition Requested',
  REQUISITION_APPROVED : 'Requisition Approved',
  REQUISITION_CHECKOUT : 'Requisition Checkout'
}

